<template>
  <div>
    <el-dropdown trigger="click" style="margin-left: 5px;margin-right: 15px;position:relative;" @command="openIm" @visible-change="getImShow">
      <el-badge :hidden="!total" :value="total" :max="99" class="right-menu-item-im">
        <svg-icon icon-class="information" style="font-size: 20px" />
      </el-badge>
      <el-dropdown-menu ref="messageDrop" slot="dropdown" class="communicate">
        <el-dropdown-item v-show="imShow">
          <span>loading...</span>
        </el-dropdown-item>
        <el-dropdown-item v-show="!imShow && innerGroup && isDropdown" :command="$t('Message.ChatInside')">
          <el-badge :hidden="!innerGroupUnreadNum" :value="innerGroupUnreadNum" :max="99">
            <span>{{ $t('Message.ChatInside') }}</span>
          </el-badge>
        </el-dropdown-item>
        <el-dropdown-item v-show="!imShow && outGroup && isDropdown" :command="$t('Message.ChatByClient')">
          <el-badge :hidden="!outGroupUnreadNum" :value="outGroupUnreadNum" :max="99">
            <span>{{ $t('Message.ChatByClient') }}</span>
          </el-badge>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { createOrJoin } from '@/api/cargoIm'
import { getImGroup } from '@/api/cargoIm'
export default {
  data() {
    return {
      unreadTotal: 0,
      innerGroupUnreadNum: 0,
      outGroupUnreadNum: 0,
      innerGroup: false,
      outGroup: false,
      imGroupName: '',
      imShow: false,
      imItemShow: false,
      openGroupData: {}
    }
  },
  computed: {
    isDropdown() {
      return this.innerGroup && this.outGroup
    },
    // 内外部群组未读数总数
    total: {
      get() {
        return this.innerGroupUnreadNum + this.outGroupUnreadNum
      },
      set(value) {
        this.innerGroupUnreadNum = value
        this.outGroupUnreadNum = value
      }
    }
  },
  watch: {
    // 单据切换时，重置未读数
    openGroupData() {
      this.total = 0
    }
  },
  mounted() {
    function receiveMessage(event) {
      if (!event.data.type || event.data.type !== 'im') {
        return
      }
      if (event.data) {
        this.unreadTotal = event.data.unreadTotal
        this.innerGroupUnreadNum = event.data.innerGroupUnreadNum
        this.outGroupUnreadNum = event.data.outGroupUnreadNum
      } else {
        this.unreadTotal = 0
      }
    }
    window.addEventListener('message', receiveMessage.bind(this), false)
  },
  methods: {
    onShow(data, imGroupName) {
      this.imGroupName = imGroupName
      this.openGroupData = data
    },
    async getImShow(value) {
      if (value) {
        this.imShow = true
        this.$refs.messageDrop.showPopper = true
        this.imItemShow = false
        const res = await getImGroup(this.openGroupData).finally(() => {
          this.imShow = false
        })
        if (res.ok && res.data) {
          if (res.data.outGroup || res.data.innerGroup) {
            this.imItemShow = true
          } else {
            this.$refs.messageDrop.showPopper = false
            this.$message.warning(this.$t('CargoMsg.Cargo_imWarning'))
          }
          this.outGroup = res.data.outGroup
          this.innerGroup = res.data.innerGroup
          this.isOpenDirectly()
        }
      }
    },
    /**
     * 如果内外部群组只存在一个情况下直接打开im
     */
    isOpenDirectly() {
      if (!this.isDropdown) {
        let group = null
        if (this.outGroup) {
          group = this.$t('Message.ChatByClient')
        } else if (this.innerGroup) {
          group = this.$t('Message.ChatInside')
        }
        group && this.openIm(group)
      }
    },
    async openIm(value) {
      if (value === this.$t('Message.ChatInside') || value === this.$t('Message.ChatByClient')) {
        const data = {
          groupName: this.imGroupName,
          tenantId: this.openGroupData.tenantId,
          cargowareCompanyId: this.openGroupData.cargowareCompanyId, // cargoware的合作伙伴，对应b2b的订舱公司
          loginUserId: this.openGroupData.loginUserId,	// 登陆人userId
          customerEmail: this.openGroupData.customerEmail, // 客户邮箱
          otherUserIdList: this.openGroupData.otherUserIdList, // 其他内部人userId，userName
          docId: this.openGroupData.docId, // 单据Id
          type: this.openGroupData.type, // 单据type
          groupType: ''
        }
        if (value === this.$t('Message.ChatInside')) {
          data.groupType = 'inner'
        }
        if (value === this.$t('Message.ChatByClient')) {
          data.groupType = 'out'
        }
        const res = await createOrJoin(data)
        if (res.ok) {
          const groupIdList = {
            innerGroupId: res.data.innerGroupId,
            outGroupId: res.data.outGroupId
          }
          this.$store.commit('DIALOG_SHOW', true)
          this.$store.commit('SET_GROUP_ID_LIST', groupIdList)
        }
      }
    }
  }
}
</script>

